import {
  BarChart3,
  Building2,
  Euro,
  FileSignature,
  Globe,
  LayoutDashboard,
  MessageSquare,
  Network,
  Settings,
} from "lucide-react";

export const adminNavigation = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard },
  { path: "/wachen", label: "Wachen", icon: Building2 },
  { path: "/netzwerke", label: "Netzwerke", icon: Network },
  { path: "/zahlungen", label: "Zahlungen", icon: Euro },
  { path: "/statistiken", label: "Statistiken", icon: BarChart3 },
  { path: "/feedback", label: "Feedback", icon: MessageSquare },
  { path: "/globale-inhalte", label: "Globale Inhalte", icon: Globe },
  { path: "/vertrags-einstellungen", label: "Vertrag & Recht", icon: FileSignature },
  { path: "/einstellungen", label: "Einstellungen", icon: Settings },
];
